"use client";

import { Image } from "@atoms/image/Image";
import { gridStyles } from "@layout/grid";
import { ApiImage } from "@page-components/types";
import { PageHeader } from "@sections/page-header/PageHeader";
import { useMultiSearch } from "@utils/search/queries/multi-search";
import { cn, tw } from "@utils/tailwind";
import { FC, useState } from "react";
import { SearchBar } from "./bar";
import { SearchHits } from "./hits";
import { SearchSuggestions } from "./suggestions";

const imageStyles = tw`-bottom-1/3
  left-0
  top-auto
  h-2/3
  object-left-top
  opacity-50
  md:opacity-100
  2xl:bottom-0
  2xl:h-2/5`;

export type SearchProps = {
  suggestions: string[];
  image?: ApiImage;
};

export const Search: FC<SearchProps> = ({ image, suggestions }) => {
  const [value, setValue] = useState("");
  const { data, isFetching, isError } = useMultiSearch(value);

  return (
    <main className="relative min-h-dvh overflow-hidden pb-10 text-content-primary-on-light xl:pb-20">
      {image && (
        <Image
          backgroundImage
          imageData={image}
          className={cn(imageStyles, value && "hidden")}
        />
      )}
      <PageHeader title="Search" className="mb-6 !pb-0 xl:mb-8" />
      <div
        className={cn(
          gridStyles.container,
          "relative" // "relative" makes it render on top of the background image
        )}
      >
        <SearchBar
          value={value}
          onChange={setValue}
          isError={isError}
          className={cn(value ? "mb-6 xl:mb-8" : "mb-10 md:mb-12 xl:mb-14")}
        />
        <SearchSuggestions
          suggestions={suggestions}
          show={!value}
          onChange={setValue}
        />
      </div>
      <SearchHits
        isFetching={isFetching}
        show={!!value}
        hits={data?.hits}
        hasMoreHits={data?.hasMoreResults}
      />
    </main>
  );
};
